import { EnvConfig } from '@sgi/af-shell-shared';

export const REMOTE_NAME = 'af_customer_portal';
export const getConfig = async () => EnvConfig.getInstance(REMOTE_NAME, `${__webpack_public_path__}config.json`).get();
